import { render, staticRenderFns } from "./PdfExportButton.vue?vue&type=template&id=450bc32b"
import script from "./PdfExportButton.vue?vue&type=script&lang=js"
export * from "./PdfExportButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports